export default {
  modelName: 'system_class',
  label: '領域',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    area: {
      type: 'belongsTo',
      label: '適用地區',
      rules: 'required',
      textKey: 'name',
      modelName: 'area',
      clearable: true,
    },
    icon: {
      type: 'image',
      label: 'Icon',
      uploadUrl: '/system_class/icon/',
      maxWidth: '100px',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'textarea',
          label: '名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 1000,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
